export const TAB_BAR_STRUCTURE = {
  home: {
    id: 'home',
    url: '',
  },
  menu: [
    {
      id: 'agency',
      url: '',
    },
    {
      id: 'agencyLI',
      url: '',
    },
    {
      id: 'hyperviseur',
      url: '',
    },
    {
      id: 'financialSpace',
      url: '',
    },
  ],
  help: [
    {
      id: 'onlineAssistanceEF',
      url: '',
    },
    {
      id: 'onlineFormation',
      url: '',
    },
    {
      id: 'contactUs',
      url: '',
    },
  ],
  account: [
    {
      id: 'accountSl',
      url: '',
    },
    {
      id: 'accountLi',
      url: '',
    },
    {
      id: 'logout',
      url: '',
    },
  ]
};
